import { useState } from 'react';
import DeleteButton from '../../../common/components/DeleteButton/DeleteButton';
import ActionGroup from '../../../common/components/ActionGroup';
import {hetch} from "../../../utils/fetch.hooked";

function ActionButtons({ id, triggerRefetch, selected, toggleInSet }) {
  const [isFetching, setIsFetching] = useState(false);

  const removeItem = () => {
    setIsFetching(true);
    hetch(`/api/sessions/${id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => {
        if (selected) toggleInSet(id, false);
        triggerRefetch();
      })
      .finally(() => setIsFetching(false));
  }

  return (
    <ActionGroup align="right">
      <DeleteButton
        title="Завершить сеанс"
        header="Подтверждение завершения"
        message="Вы действительно хотите завершить сеанс?"
        yesText="Завершить"
        isFetching={isFetching}
        onConfirm={removeItem}
      />
    </ActionGroup>
  );
}

export default ActionButtons;
